import React, { useState } from 'react';
import PageContent from '../../../components/page-content';
import Heading from '../../../components/heading';
import { Button, Card } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBuildingCircleExclamation, faBuildingFlag, faN, faSave } from '@fortawesome/free-solid-svg-icons';

export default function SaveClaim ({ claimId }) {

    const [claim, setClaim] = useState({
        claimant: '',
        email: '',
        phone: '',
        amount: 0,
        currency: 'USD',
        dateOfLoss: '',
        causeOfLoss: '',
        description: ''
    });

    const [errors, setErrors] = useState({});

    const handleChange = (e) => {
        const { name, value } = e.target;
        setClaim(prevState => ({
            ...prevState,
            [name]: value
        }));
    };

    const validateClaim = (claim) => {
        const errors = {};

        if (!claim.claimant) {
            errors.claimant = 'Claimant is required';
        }

        if (!claim.email) {
            errors.email = 'Email is required';
        } else if (!/\S+@\S+\.\S+/.test(claim.email)) {
            errors.email = 'Email address is invalid';
        }

        if (!claim.phone) {
            errors.phone = 'Phone is required';
        } else if (!/^\+(?:[0-9] ?){6,14}[0-9]$/.test(claim.phone)) {
            errors.phone = 'Phone number is invalid';
        }

        if (!claim.amount) {
            errors.amount = 'Amount is required';
        }

        if (!claim.currency) {
            errors.currency = 'Currency is required';
        }

        if (!claim.dateOfLoss) {
            errors.dateOfLoss = 'Date of Loss is required';
        }

        if (!claim.causeOfLoss) {
            errors.causeOfLoss = 'Cause of Loss is required';
        }

        if (!claim.description) {
            errors.description = 'Description is required';
        }

        return {
            errors,
            isValid: Object.keys(errors).length === 0
        };
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        const { errors, isValid } = validateClaim(claim);
        if (!isValid) {
            setErrors(errors);
        } else {
            setErrors({});
        }
    }

    return (
       <>
        <PageContent>
            <Heading>
                <div className={`d-flex justify-content-between align-items-center mb-4 border-bottom pb-2`}>
                    <h2 className="">
                        {claimId ? 'Modifier le sinistre' : 'Nouveau sinistre'}
                    </h2>

                    <div className="d-flex align-items-center gap-2">
                        <Button variant="primary" className="ms-2">
                            <FontAwesomeIcon icon={faSave} className={`me-2`} />
                            Enregistrer
                        </Button>
                    </div>
                </div>              
            </Heading>

            <Card className={`animate__animated animate animate__fadeIn mt-4`}>
                <Card.Body className={`d-flex flex-column justify-content-center align-items-center p-4 gap-4`}>
                    {/* Work in progress icon */}
                    <FontAwesomeIcon icon={faBuildingCircleExclamation} size="6x" className={`text-warning`} />
                    <div className={`text-center`}>
                        <h5 className="mb-0">Travail en cours</h5>
                        <div className="mb-0 text-muted">Cette page est en cours de développement</div>
                    </div>
                </Card.Body>
            </Card>
        </PageContent>
       </>
    )
}